<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" v-model="liveFilters.pharmacy" :items="filterListData.pharmacyList" item-text="name" item-value="id" label="Pharmacy" multiple outline hide-details />
      <DateRangePicker header="Date Range" :value="liveFilters.dateRange || { from: claimsDate.min, to: claimsDate.max }" :min="claimsDate.min" :max="claimsDate.max" @input="dateSelected" />
      <loader v-if="isFiltering.filterList" />
    </template>
    <div class="col-12 p-4">
      <div class="spcore-box white p-3">
        <div class="pb-3">
          <h2 class="hvh-h6">Patients Metrics</h2>
        </div>
        <div class="hvh-flex wrap">
          <div class="col-12 col-md-6 p-0 pr-2 mb-3">
            <h2 class="hvh-h6 normal">Time to Fill</h2>
            <LineChart :chartData="chartData" :options="chartOptions('Days')" height="300px" @chart-created="$emit('refresh-data', $event)" />
            <div class="chart-x-axis">Date</div>
          </div>
          <div class="col-12 col-md-6 p-0 pl-2 mb-3">
            <h2 class="hvh-h6 normal">Fill Rate</h2>
            <LineChart :chartData="chartData" :options="chartOptions('Percentage')" height="300px" @chart-created="$emit('refresh-data', $event)" />
            <div class="chart-x-axis">Date</div>
          </div>
          <div class="splitter w-100 mb-3" />
          <div class="col-12 p-0">
            <h2 class="hvh-h6 normal">MPR</h2>
            <LineChart :chartData="chartData" :options="chartOptions('Percentage')" height="300px" @chart-created="$emit('refresh-data', $event)" />
            <div class="chart-x-axis">Date</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-4">
      <div class="spcore-box white p-3">
        <div class="pb-3">
          <h2 class="hvh-h6">Product Metrics</h2>
        </div>
        <div class="hvh-flex wrap">
          <div class="col-12 col-sm-6 p-0 pr-2">
            <h2 class="hvh-h6 normal">Sales Benchmark</h2>
            <LineChart :chartData="chartData" :options="chartOptions('Volume')" height="300px" @chart-created="$emit('refresh-data', $event)" />
            <div class="chart-x-axis">Date</div>
          </div>
          <div class="col-12 col-sm-6 p-0 pl-2">
            <h2 class="hvh-h6 normal">Inventory Benchmark</h2>
            <LineChart :chartData="chartData" :options="chartOptions('Volume')" height="300px" @chart-created="$emit('refresh-data', $event)" />
            <div class="chart-x-axis">Date</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-4">
      <div class="spcore-box white w-100 p-3">
        <h2 class="hvh-h6">Data Metrics</h2>
        <table class="spcore-brand-table w-100">
          <tr>
            <th />
            <th>Annon Pharma</th>
            <th>Network</th>
          </tr>
          <tr v-for="(item, ind) in dataMetricsData.head()" :key="ind">
            <td class="bold">{{ item[0] }}</td>
            <td>
              <div class="hvh-flex center">
                <SPCorePercentageCircle :value="item[1]" />
                <span class="ml-2 w-40px">{{ item[1] }}%</span>
              </div>
            </td>
            <td>
              <div class="hvh-flex center">
                <SPCorePercentageCircle :value="item[2]" />
                <span class="ml-2 w-40px">{{ item[2] }}%</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="bold">{{ dataMetricsData.last()[0] }}</td>
            <td>
              <div class="hvh-flex center">
                <SPCorePercentageSchell :value="dataMetricsData.last()[1]" />
              </div>
            </td>
            <td>
              <div class="hvh-flex center">
                <SPCorePercentageSchell :value="dataMetricsData.last()[2]" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <loader v-if="isFiltering" />
  </SPCoreShell>
</template>
  
<script>
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import DateRangePicker from '../../components/common/date/DateRangePicker.vue';
import { getDemographics } from '../../libraries/cohorts';
import data from './data/line-chart-sample.json'
import LineChart from '../../components/charts/LineChart.vue';
import SPCorePercentageCircle from '../../components/spcore/SPCorePercentageCircle.vue';
import SPCorePercentageSchell from '../../components/spcore/SPCorePercentageSchell.vue';
export default {
  title: 'Pharmacy Network',
  components: { SPCoreShell, DateRangePicker, LineChart, SPCorePercentageCircle, SPCorePercentageSchell, },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: {},
      filterListData: {},
      claimsDate: { min: new Date('2015-01-01').toISOString(), max: new Date().toISOString() },
      isFiltering: false,
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
      chartData: data,
      dataMetricsData: [
        ['On Time', 95, 82],
        ['Complete', 95, 100],
        ['Accurate', 100, 95],
        ['Overall Data Score', 95, 90],
      ],
    };
  },
  computed: {

  },
  methods: {
    loadSankeyData() {

    },
    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    dateSelected(event) {
      this.liveFilters = {
        ...this.liveFilters,
        dateRange: event
      };
    },
    chartOptions(yAxisName) {
      return {
        yAxis: {
          name: yAxisName,
          nameGap: 60,
          nameTextStyle: {
            fontWeight: 'bold',
            fontSize: 13
          },
        },
      }
    },
  }
}
</script>
  
<style lang="scss" scoped>
.splitter {
  border: 1px solid #b0b3b6;
}

.spcore-brand-table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;

  td,
  th {
    border: 0px solid #ddd;
    padding: 8px;
    font-size: 15px;
  }

  th:not(:first-child) {
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:hover {
    background-color: #ddd;
  }

  th {
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: left;
  }
}

.overall-percentage {
  display: inline-block;
  padding: 2px 10px;
}

.chart-x-axis {
  text-align: center;
  font-weight: 700;
  font-size: 10px;
}
</style>